import Vue from "vue";
import App from "./App.vue";
import InstantSearch from "vue-instantsearch";
import VueSocialSharing from "vue-social-sharing";

import "../node_modules/bulma/css/bulma.min.css";
import "../node_modules/@creativebulma/bulma-collapsible/dist/css/bulma-collapsible.min.css";
import "../node_modules/@creativebulma/bulma-tooltip/dist/bulma-tooltip.min.css";
import "../node_modules/bulma-popover/css/bulma-popver.min.css";

Vue.use(InstantSearch);
Vue.use(VueSocialSharing);

// eslint-disable-next-line no-new
new Vue({
  el: "#app",
  render: h => h(App)
});
